import { ScoreType } from '../../../../../../store/admin/eventFormats/store';
import { IAdminFlight } from '../../../../../../store/admin/eventFlights/store';
import { IFormat } from '../../../../../../store/admin/roundFormats/store';

import { ICombination } from './AssignResults.context';

interface IStateArgs {
  selectedScoreType: ScoreType | undefined;
  selectedFlight: IAdminFlight | undefined;
  selectedFormat: IFormat | undefined;
}

type IFilterCombinations = (state: IStateArgs) => (combination: ICombination) => boolean;

export const filterCombinations: IFilterCombinations = state => combination => {
  const { selectedScoreType, selectedFlight, selectedFormat } = state;

  const { flight, format, scoreType } = combination;

  if (!format) {
    return false;
  }

  const {
    format: { id: formatId, prefix }
  } = format;

  const scoreTypeIsSelected = !selectedScoreType || scoreType === selectedScoreType;
  const flightIsSelected = !selectedFlight || !flight || flight.id === selectedFlight.id;
  const formatIsSelected = !selectedFormat || formatId === selectedFormat.id;
  const isCTPNet = prefix.includes('ctp') && scoreType === 2;
  const isGrossBeatNet = prefix.includes('gbn') && scoreType === 2;

  return (
    scoreTypeIsSelected && flightIsSelected && formatIsSelected && !isCTPNet && !isGrossBeatNet
  );
};
